module.exports = __webpack_public_path__ + "static/Nick_Clear_Headshot-12491f59986ee6f46c8aa9e9252ceae5.jpg";